import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { FiX } from "react-icons/fi";

const AdsNoticeCreate = () => {
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { notice_no: noticeId } = useParams(); 
    const [isDisplay, setIsDisplay] = useState(true); // 노출 여부. UI 없으면 기본 true로 유지

    const handleTitleChange = (e) => setTitle(e.target.value);
    const handleContentChange = (e) => setContent(e.target.value);

    const location = useLocation();
    const noticeFromState = location.state?.notice;
    const storeBusinessNumber = location.state.storeBusinessNumber;
    const type = location.state?.type || ""
    const [file, setFile] = useState(null);
    const MAX_SIZE_MB = 10;
    // const [previewUrl, setPreviewUrl] = useState("");
    const [existingFile, setExistingFile] = useState(""); // 서버 저장된 기존 파일 경로
    const [removed, setRemoved] = useState(false);        // 삭제 의도
    
    const fileInputRef = useRef(null);
    const isEdit = !!noticeId;

    // 🔹 수정 모드일 경우 기존 데이터 불러오기
    useEffect(() => {
        if (!isEdit) return;
        // state에서 전달받은 공지사항이 있다면 그걸로 초기화
        if (noticeFromState) {
            const nf  = noticeFromState;
            const f   = nf.notice_file ?? nf.NOTICE_FILE ?? "";
            setTitle(nf.notice_title ?? nf.NOTICE_TITLE ?? "");
            setContent(nf.notice_content ?? nf.NOTICE_CONTENT ?? "");
            setIsDisplay(((nf.notice_post ?? nf.NOTICE_POST) ?? "Y") === "Y");
            setExistingFile(f || "");
            setRemoved(false);
            return;
        }
        // 서버에서 단건 조회 (배열/객체 모두 처리)
        // else if (noticeId) {
        (async () => {
            // const fetchNotice = async () => {
            try {
                const { data } = await axios.get(
                    `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/get/notice/${noticeId}`,
                    {params: { admin: true },
            });
                const item = Array.isArray(data) ? data[0] : data;
                setTitle(item?.notice_title);
                setContent(item?.notice_content);
                setIsDisplay((item?.notice_post ?? "Y") === "Y");
                setExistingFile(item?.notice_file || "");
                setRemoved(false);
            } catch (err) {
                setError("공지사항을 불러오는 데 실패했습니다.");
            }
        })();
            // fetchNotice();
        // }
    }, [isEdit, noticeId, noticeFromState]);

    
    const handleFileChange = (e) => {
        const f = e.target.files?.[0];
        if (!f) return;
        if (!f.type.startsWith("image/")) return alert("이미지 파일만 등록 가능합니다.");
        if (f.size > MAX_SIZE_MB * 1024 * 1024) return alert(`최대 ${MAX_SIZE_MB}MB까지 업로드 가능합니다.`);
        setFile(f);
        setRemoved(false);
        setExistingFile("");
    };

    // 파일 제거(프론트 상태)
    const handleFileClear = () => {
        setFile(null);
        // setPreviewUrl("");
        setRemoved(true);              // 저장 시 삭제 의도 전달
        setExistingFile("");
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!title || !content) {
            setError("제목과 내용을 모두 입력해주세요.");
            return;
        }

        setLoading(true);
        setError("");

        try {
            const form = new FormData();
            form.append("notice_title", title.trim());
            form.append("notice_content", content.trim());
            form.append("notice_post", isDisplay ? "Y" : "N"); // 백엔드와 키 맞추기
            if (file) {
                form.append("notice_file", file) // 파일 교체
            } else if (isEdit && removed) {
                form.append("remove_file", "true"); // 파일 삭제 의도만 전달 (유지/삭제 구분)
            };

            const url = noticeId
                ? `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/edit/notice/${noticeId}`
                : `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/create/notice`;

            await axios.post(url, form, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            // if (noticeId) {
            //     // 수정
            //     await axios.post(
            //         `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/edit/notice/${noticeId}`,
            //         {
            //             notice_no: noticeId,
            //             notice_title: title,
            //             notice_content: content,
            //         }
            //     );
            // } else {
            //     // const response =
            //     await axios.post(
            //         `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/create/notice`,
            //         {
            //             notice_title: title,
            //             notice_content: content,
            //         }
            //     );
            // }

            // if (response.status === 201) {
            navigate("/ads/notice", {
                state: { storeBusinessNumber, type, noticeUpdated: true },
            });
            // }
        } catch (error) {
            setError("공지사항을 생성하는데 실패했습니다. 다시 시도해주세요.");
            console.error("공지사항 생성 실패:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleGoToList = () =>
        navigate("/ads/notice", {
            state: { storeBusinessNumber: storeBusinessNumber, type: type },
        });

    return (
        <div className="max-w-lg mx-auto p-6">
            {/* 제목과 목록 버튼을 나란히 배치 */}
            <div className="flex justify-between items-center pb-4">
                <h2 className="text-2xl font-bold">
                    {!!noticeId ? "공지사항 수정" : "공지사항 작성"}
                </h2>
                <button
                    onClick={handleGoToList}
                    className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700"
                >
                    목록
                </button>
            </div>

            {error && <div className="text-red-600 pb-4">{error}</div>}

            <form onSubmit={handleSubmit} className="space-y-4">
                {/* 노출 여부 */}
                <div>
                    <span className="block text-sm font-medium text-gray-700 mb-2">노출</span>
                    <div className="flex items-center gap-6">
                        <label className="inline-flex items-center gap-2">
                            <input
                                type="radio"
                                name="display"
                                checked={isDisplay === true}
                                onChange={() => setIsDisplay(true)}
                            />
                            <span>Yes</span>
                        </label>
                        <label className="inline-flex items-center gap-2">
                            <input
                                type="radio"
                                name="display"
                                checked={isDisplay === false}
                                onChange={() => setIsDisplay(false)}
                            />
                            <span>No</span>
                        </label>
                    </div>
                </div>
                <div>
                    <label
                        htmlFor="title"
                        className="block text-sm font-medium text-gray-700"
                    >
                        제목
                    </label>
                    <input
                        type="text"
                        id="title"
                        value={title}
                        onChange={handleTitleChange}
                        className="pt-1 block w-full p-2 border border-gray-300 rounded-lg"
                        placeholder="공지사항 제목을 입력하세요"
                    />
                </div>

                <div>
                    <label
                        htmlFor="content"
                        className="block text-sm font-medium text-gray-700"
                    >
                        내용
                    </label>
                    <textarea
                        id="content"
                        value={content}
                        onChange={handleContentChange}
                        className="pt-1 block w-full min-h-[250px] p-2 border border-gray-300 rounded-lg"
                        rows="4"
                        placeholder="공지사항 내용을 입력하세요"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700">첨부파일</label>
                    <div className="mt-1 flex items-center gap-2">
                        <input
                            type="text"
                            readOnly
                            value={file ? file.name : removed ? "선택된 파일 없음" : (existingFile ? existingFile.split("/").pop() : "선택된 파일 없음")}
                            className="flex-1 rounded-lg border px-3 py-2 text-sm text-neutral-700"
                        />
                        {/* X 버튼 노출: 기존 파일도 있을 땐 보여주기 */}
                        {(file || (existingFile && !removed)) && (
                            <button
                                type="button"
                                onClick={handleFileClear}
                                className="inline-flex items-center justify-center rounded-lg border px-2 py-2 text-sm hover:bg-neutral-50"
                                aria-label="첨부파일 제거"
                            >
                                <FiX className="w-4 h-4" />
                            </button>
                        )}
                        <label className="relative inline-flex items-center justify-center rounded-lg bg-neutral-200 px-3 py-2 text-sm cursor-pointer hover:bg-neutral-300">
                            찾아보기
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                                ref={fileInputRef}
                                className="absolute inset-0 opacity-0 cursor-pointer"
                            />
                        </label>
                    </div>
                    <p className="mt-1 text-xs text-neutral-500">
                        *사진(이미지)만 등록 가능합니다. (최대 {MAX_SIZE_MB}MB 등록 가능)
                    </p>
                </div>

                <button
                    type="submit"
                    disabled={loading}
                    className="w-full bg-blue-600 text-white p-2 rounded-lg hover:bg-blue-700 disabled:opacity-50"
                >
                    {/* {loading ? "작성 중..." : "작성 완료"} */}
                    {loading
                        ? !!noticeId
                            ? "수정 중..."
                            : "작성 중..."
                        : !!noticeId
                        ? "수정 완료"
                        : "작성 완료"}
                </button>
            </form>
        </div>
    );
};

export default AdsNoticeCreate;
